import { useState } from 'react';
import { NotebookPen } from 'lucide-react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { hasRequiredNotes } from '../../utils/helpers';

const PLACEHOLDERS = {
  required: "Tell us why you're coming in, and if you're in any pain",
  optional: 'Add any notes for your appointment (optional)',
} as const;

const REQUIRED_ERROR = 'Please add a note for this appointment';

interface AppointmentNotesFieldProps {
  value?: string;
  onChange: (value: string) => void;
  rows?: number;
  placeholder?: string;
}

export const AppointmentNotesField = ({ value, onChange, rows = 2, placeholder }: AppointmentNotesFieldProps) => {
  const notesRequired = useSelector((s: RootState) => s.appointment.treatment?.notesRequired);
  const [touched, setTouched] = useState(false);
  const showError = touched && !hasRequiredNotes(notesRequired, value);

  return (
    <div className="form-control h-full">
      <label className="label">
        <span className="label-text font-semibold text-gray-500">
          Appointment Notes {notesRequired && <span className="text-error">*</span>}
        </span>
      </label>
      <div className="relative flex-1">
        <div className="pointer-events-none absolute left-3 top-3">
          <NotebookPen size={18} className="text-gray-400" />
        </div>
        <textarea
          className={`textarea textarea-bordered w-full md:h-full pl-10 bg-transparent text-black placeholder-gray-400 ${showError ? 'border-error focus:border-error' : 'border-teamcare-blue'}`}
          rows={rows}
          placeholder={notesRequired ? PLACEHOLDERS.required : (placeholder ?? PLACEHOLDERS.optional)}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => setTouched(true)}
        />
      </div>
      {showError && (
        <label className="label">
          <span className="label-text-alt text-error">{REQUIRED_ERROR}</span>
        </label>
      )}
    </div>
  );
};
